import React, { useState } from "react";
import axios from "axios";

const EditClients = () => {
  const [client, setClient] = useState({
    id: "",
    name: "",
    email: "",
    phone: "",
  });

  const handleChange = (e) => {
    setClient({ ...client, [e.target.name]: e.target.value });
  };

  const updateClient = async () => {
    try {
      await axios.post(
        "https://streamsrvbac.n-tools.info/keymanage/clients/update",
        client
      );

      alert("Client updated successfully");
    } catch (err) {
      alert("Update failed");
    }
  };

  return (
    <div style={{ padding: 20, color: "white" }}>
      <h2>Edit Client</h2>

      <input name="id" placeholder="Client ID" onChange={handleChange} />
      <input name="name" placeholder="Name" onChange={handleChange} />
      <input name="email" placeholder="Email" onChange={handleChange} />
      <input name="phone" placeholder="Phone" onChange={handleChange} />

      <button onClick={updateClient}>Update</button>
    </div>
  );
};

export default EditClients;
